import React from 'react';
import {Form} from 'react-bootstrap';

interface ThresholdSettingsProps {
    threshold: number;
    isDisabled: boolean;
    onThresholdChange: (value: number) => void;
}

const ThresholdSettings: React.FC<ThresholdSettingsProps> = ({
                                                                 threshold,
                                                                 isDisabled,
                                                                 onThresholdChange,
                                                             }) => (
    <div className="d-flex flex-column gap-2">
        <span>Threshold: {threshold}</span>
        <Form.Control
            disabled={isDisabled}
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={threshold}
            onChange={(e) => onThresholdChange(parseFloat(e.target.value))}
        />
    </div>
);

export default ThresholdSettings;
